import EdoFundsPortfolio from "./EdoFundsPortfolio";

export default EdoFundsPortfolio;
